import { Redirect } from 'react-router-dom';
import { Component } from 'react';
import { ROLES } from 'services/constants';

export default WrappedComponent => {
  class AuthHOC extends Component {
    render() {
      const role = localStorage.getItem('um_role');
      const token = localStorage.getItem('token');
      return (
        role === ROLES.STAFF ||
        role === ROLES.RADIOLOGY ||
        role === ROLES.PRACTITIONER) && token ? (
          <WrappedComponent {...this.props} />
        ) : (
          <Redirect to="/practitioner" />
        );
    }
  }

  return AuthHOC;
};
